module.exports = __webpack_public_path__ + "static/img/Free Fire.22edd403.png";